import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Button, Link, Typography, useMediaQuery } from "@mui/material";
import { MDXRemote } from "next-mdx-remote";
import { useTranslation } from "next-i18next";

import BlogCover from "./BlogCover";
import BlogImage from "./BlogImage";
import BlogParagraph from "./BlogParagraph";
import Blockquote from "./Blockquote";
import { H2, H3, H4 } from "./Titles";
import BackButton from "./BackButton";
import Author from "./Author";
import Container from "../Common/Container";
import ArticlePipedriveForm from "./ArticlePipedriveForm";

const components = {
  a: (props) => <Link target="_blank" {...props} />,
  img: (props) => <BlogImage {...props} />,
  p: BlogParagraph,
  h2: H2,
  h3: H3,
  h4: H4,
  blockquote: Blockquote,
};

const Article = ({ content, headline, context, meta }) => {
  const { t } = useTranslation("common");
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const { title, coverImage, publishedAt, form_id, resourceUrl } = meta;

  return (
    <article>
      <Container maxWidth={760}>
        <Box mb={2}>
          <BackButton href={`/${context}`}>{t(`navbar.${context}`)}</BackButton>
        </Box>

        <Box mb={1}>
          <Typography variant="h3" component="h1" sx={{ fontWeight: "bold" }}>
            {title}
          </Typography>
        </Box>

        <Box mb={2}>
          <Author date={publishedAt} />
        </Box>

        {headline && (
          <Typography
            variant="h6"
            component="div"
            sx={{ mb: 4, lineHeight: "1.8rem" }}
          >
            <MDXRemote components={components} {...headline} />
          </Typography>
        )}

        {coverImage && (
          <Box mb={4}>
            <BlogCover src={coverImage} alt="Blog cover image" />
          </Box>
        )}

        {content && (
          <Box sx={{ lineHeight: "1.8rem" }}>
            <Typography component="div">
              <MDXRemote components={components} {...content} />
            </Typography>
          </Box>
        )}

        {resourceUrl && (
          <Button
            variant="contained"
            color="primary"
            component="a"
            target="_blank"
            size="large"
            fullWidth={isMd ? false : true}
            href={resourceUrl}
          >
            {t("common.download_file")}
          </Button>
        )}
      </Container>

      {form_id && <ArticlePipedriveForm formId={form_id} />}
    </article>
  );
};

export default Article;
